module.exports = __webpack_public_path__ + "img/companyEle.646bf5db.svg";